import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import ErrorWrapper from '../../../lib/error_wrapper';
import { Spin, PageHeader, Button, Statistic, Badge, Descriptions, Popconfirm, message, Divider, Row, Tag, Tabs } from 'antd';
import { showErrorInNotification, overrideHeaderTitle, overrideHeaderBack, showSuccessInNotification } from '../../../lib/util';
import { PopUpForm } from '../../../lib/ui/popupform';
import ReconcilerAssigner from './reconciler_assigner';
import DataTypeAssigner from './datatype_assigner';
import GroupAssigner from './group_assigner';
import TableAssigner from './table_assigner';
import RepositoryAssigner from './repository_assigner'
import Title from 'antd/lib/typography/Title';
import { BasicHeader } from '../../../components/basic_header';
import { COLORS } from '../../theme';


const password_schema = [
  {
    index: "password",
    name: "New Password",
    type: 'password'
  }
]
class UserDetail extends Component {
  constructor(props) {
    super(props)

    this.user_id = props.match.params.user_id;

    this.state = {
      loading: true,
      user_detail: {},
      password_change_visibility: false
    };
    this.get_user = RESTExecutor.detail().config({
      label: 'user_detail'
    }).callbacks((success) => {
      this.setState({
        loading: false,
        user_detail: success.result
      });

      //   try{
      //     window.header_assigner.assignTitle(`${success.result.username}`);

      // }catch(e){}

    }, (error) => {
      this.setState({ loading: false })
    }).forId(this.user_id).connect(props.domains.users);

    this.update_user = RESTExecutor.patch().config({
      label: 'user_revoke'
    }).callbacks((success) => {
      this.setState({ loading: true })
      this.get_user.forId(this.user_id).execute();
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.users);

    this.enable_user = RESTExecutor.post().config({
      label: 'enable_user'
    }).callbacks((success) => {
      showSuccessInNotification(success, "User Enabled")
      this.setState({ loading: true })
      this.get_user.forId(this.user_id).execute();
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.users);

    this.disable_user = RESTExecutor.post().config({
      label: 'disable_user'
    }).callbacks((success) => {
      showSuccessInNotification(success, "User Disabled")
      this.setState({ loading: true })
      this.get_user.forId(this.user_id).execute();
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.users);


    this.change_password = RESTExecutor.post().config({
      label: 'change_password'
    }).callbacks((success) => {
      this.setState({ password_change_visibility: false });
      showSuccessInNotification(success, "Password Reset Completed")
    }).connect(props.domains.users);


    this.get_user.execute();

  }

  disableEnableUser = (disabled) => {
    if(disabled){
      // trigger enable
      this.enable_user.forId(this.user_id).execute()
    }else{
      this.disable_user.forId(this.user_id).execute()
    }
    // this.update_user.forId(this.user_id).execute({
    //   disabled: newStatus
    // })
  }



  render() {
    const { loading, user_detail } = this.state;
    if (loading) return <center><Spin /></center>
    let get_user_resp = this.get_user.response();
    let references = user_detail.__references__ || {};
    let roles = references.roles || [];

    let roles_extra = roles.map((role) => {
      return <Tag key={role.role_id} color={COLORS.primary}>
        {role.role_id}
      </Tag>
    })
    let change_password_resp = this.change_password.response();
    return (
      <ErrorWrapper
        error={get_user_resp}
        onReload={() => {
          this.setState({ loading: true })
          this.get_user.forId(this.user_id).execute();
        }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
        }}>
          <BasicHeader title={user_detail.name} />
          <div className='default-card' style={{
            padding: 8
          }}>
            <PopUpForm
              title="Password"
              forCreate={false}
              initialData={{}}
              fields={password_schema}
              open={this.state.password_change_visibility}
              networkState={change_password_resp}
              onClose={() => {
                this.setState({ password_change_visibility: false, })
              }}
              onSubmit={(data) => {
                console.log("change data", data);
                this.change_password.forId(this.user_id).execute(data)
              }} />

            <div>
              <PageHeader
                style={{
                  padding: 8
                }}
                // onBack={() => this.props.history.goBack()}
                title={user_detail.username}
                subTitle={<Badge status={user_detail.disabled ? 'error' : 'success'} text={user_detail.disabled ? "Disabled" : "Active"} />}
                extra={roles_extra}
                footer={<Row type='flex' justify='end'>
                  <Popconfirm title="Are you sure you want to do this action?" onConfirm={() => {
                    this.disableEnableUser(user_detail.disabled)

                  }}>
                    <Button type={user_detail.disabled ? 'primary' : 'danger'} style={{ marginRight: 16 }}>
                      {user_detail.disabled ? "Enable" : "Disable"}
                    </Button>
                  </Popconfirm>
                  <Button type='dashed' onClick={() => {
                    this.setState({
                      password_change_visibility: true
                    })
                  }}>Change Password</Button>
                </Row>}
              >
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  flexWrap: 'nowrap'
                }}>
                  {/* <div> */}
                  <Descriptions column={1} style={{
                    width: 'fit-content'
                  }}>
                    <Descriptions.Item label="Full Name">{user_detail.name}</Descriptions.Item>
                    <Descriptions.Item label="Email">{user_detail.email}</Descriptions.Item>
                    <Descriptions.Item label="Phone">{user_detail.phone}</Descriptions.Item>
                  </Descriptions>
                  {/* </div> */}
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      justifyContent: 'flex-end',
                    }}
                  >
                  </div>

                </div>
              </PageHeader>

            </div>
          </div>
          <Divider style={{ marginBottom: 14 }} />

          <Tabs style={{
            padding: 8
          }} tabPosition='top'>
            <Tabs.TabPane key={'table'} tab="Tables">
              <div className='default-card' style={{
                margin: 0,
                paddingBottom: 16,
                paddingTop: 16

              }}>
                <TableAssigner user_id={this.user_id} key={`user-${this.user_id}`} />
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane key={'group'} tab="Groups">
              <div className='default-card' style={{
                margin: 0,
                paddingBottom: 16,
                paddingTop: 16

              }}>
                <GroupAssigner user_id={this.user_id} key={`user-${this.user_id}`} />
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane key={'repository'} tab="Repository">
              <div className='default-card' style={{
                margin: 0,
                paddingBottom: 16,
                paddingTop: 16

              }}>
                <RepositoryAssigner user_id={this.user_id} key={`user-${this.user_id}`} />
              </div>
            </Tabs.TabPane>



            {/* <Tabs.TabPane key={'datatype'} tab="Datatype">
          <div className='default-card' style={{
            margin:0,
            paddingBottom:16,
            paddingTop:16
            
          }}>
          <DataTypeAssigner user_id={this.user_id} key={`user-${this.user_id}`}/>
          </div>
          </Tabs.TabPane>
          <Tabs.TabPane key='process'  tab="Process">
          <div className='default-card' style={{
            margin:0,
            paddingBottom:16,
            paddingTop:16
            
          }}>
          <ReconcilerAssigner  user_id={this.user_id} key={`user-${this.user_id}`}/>
        </div>
          </Tabs.TabPane> */}

          </Tabs>
        </div>
      </ErrorWrapper>
    );
  }

  componentDidMount() {


  }
  componentWillUnmount() {
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.match.params.user_id !== prevProps.match.params.user_id) {
      this.user_id = this.props.match.params.user_id;
      this.setState({
        loading: true,
      })
      this.get_user.forId(this.user_id).execute()
    };
  };


}

export default withDomains(UserDetail, "users");
